import { Button } from '@/components/ui/button';
import { Dropdown } from '@/components/ui/dropdown';
import { Input } from '@/components/ui/input';
import { MailSuccessDialog } from '@/components/ui/mail-success-dialog';
import { TextArea } from '@/components/ui/textarea';
import NetworkService from '@/services/network.service';
import { ChangeEvent, FormEvent, useMemo, useState } from 'react';
import InfoJson from '@/config/info.json';
import MailJson from '@/config/mail.json';
import { DropdownData } from '@/components/ui/dropdown-container';
import { sentryCaptureException } from '@/utility';

export const StatusData: DropdownData[] = [
  {
    label: 'Status',
    value: 'Status',
    disabled: true,
  },
  {
    label: 'Citizen/PR',
    value: 'Citizen/PR',
  },
  {
    label: 'Work Permit',
    value: 'Work Permit',
  },
  {
    label: 'Student',
    value: 'Student',
  },
  {
    label: 'Visitor',
    value: 'Visitor',
  },
  {
    label: 'International',
    value: 'International',
  },
];

export const InterestedData: DropdownData[] = [
  {
    label: 'Interested To',
    value: 'Interested To',
    disabled: true,
  },
  {
    label: 'Buy',
    value: 'Buy',
  },
  {
    label: 'Sell',
    value: 'Sell',
  },
  {
    label: 'Rent',
    value: 'Rent',
  },
  {
    label: 'Invest',
    value: 'Invest',
  },
];
const initialValues = {
  email: '',
  name: '',
  description: '',
  lookingFor: '',
  status: StatusData[0]?.value,
  interestedOption: InterestedData[0]?.value,
  lowerRange: '',
  upperRange: '',
  appointmentInterested: false,
};
export function ContactForm() {
  const [form, setForm] = useState(initialValues);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);

  const selectedInterestedOption = useMemo(() => {
    if (!form.interestedOption) return null;
    return InterestedData.find((x) => x.value === form.interestedOption);
  }, [form.interestedOption]);

  const handleDropdownChange = (
    key: keyof typeof initialValues,
    data: string | string[]
  ) => {
    setForm((prev) => ({ ...prev, [key]: data }));
  };

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    try {
      setLoading(true);

      const client = new NetworkService();
      await client.post('/api/mail', {
        name: form.name,
        email: form.email,
        looking_for: form.lookingFor,
        status: form.status,
        interested_in: form.interestedOption,
        lower_range: form.lowerRange ? form.lowerRange : 'N/A',
        upper_range: form.upperRange ? form.upperRange : 'N/A',
        additional_info: form.description,
        interested_for_appointment: form.appointmentInterested
          ? 'Yes, Interested'
          : 'Not Interested',
        text: `${form.name} has submitted selling with you request!`,
        subject: `${InfoJson.name} : ${form.name} submitted selling request!`,
        templateId: 'sellWithUs',
      });

      setForm(initialValues);

      setLoading(false);
      setOpen(true);
    } catch (err) {
      setLoading(false);
      sentryCaptureException(err);
    }
  };

  const handleChange = (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setForm((prev) => ({
      ...prev,
      [e.target.name]:
        e.target.type === 'checkbox' ? !prev[e.target.name] : e.target.value,
    }));
  };
  return (
    <form className="w-full space-y-4" onSubmit={handleSubmit}>
      <div className="grid grid-cols-1 gap-8 md:grid-cols-2">
        <Input
          placeholder="Your Name *"
          value={form.name}
          name="name"
          onChange={handleChange}
          variant="default"
        />
      </div>
      <div className="grid grid-cols-1 gap-8 md:grid-cols-2">
        <Input
          placeholder="Your email address *"
          value={form.email}
          name="email"
          onChange={handleChange}
          type="email"
          variant="default"
        />
      </div>
      <div className="grid grid-cols-1 gap-8 md:grid-cols-2">
        <Input
          placeholder="What kind of home are you looking for?"
          value={form.lookingFor}
          name="lookingFor"
          onChange={handleChange}
          variant="default"
        />
      </div>
      <div className="grid grid-cols-1 gap-8 md:grid-cols-2">
        <Dropdown
          data={StatusData}
          selectedValue={form.status}
          onChangeValue={(d) => handleDropdownChange('status', d)}
          // label="Status"
        />
      </div>

      <div className="grid grid-cols-1 gap-8 md:grid-cols-2">
        <Dropdown
          data={InterestedData}
          selectedValue={form.interestedOption}
          onChangeValue={(d) => handleDropdownChange('interestedOption', d)}
          // label="Interested To"
        />
        {!selectedInterestedOption?.disabled && (
          <div className="grid grid-cols-2 gap-8">
            <Input
              placeholder="Lower Range"
              // label="Lower Range"
              value={form.lowerRange}
              name="lowerRange"
              onChange={handleChange}
              type="number"
            />
            <Input
              placeholder="Upper Range"
              // label="Upper Range"
              value={form.upperRange}
              name="upperRange"
              onChange={handleChange}
              type="number"
            />
          </div>
        )}
      </div>
      <TextArea
        placeholder="Additonal information that am looking for"
        rows={4}
        className="resize-none"
        value={form.description}
        name="description"
        onChange={handleChange}
      />
      <div className="flex items-center space-x-3">
        <input
          name="appointmentInterested"
          type="checkbox"
          checked={form.appointmentInterested}
          onChange={handleChange}
          id="wishBooking"
        />
        <label htmlFor="wishBooking">
          Would you like to book an appointment to discuss further?
        </label>
      </div>

      <div className="flex justify-end flex-1">
        <Button className="font-bold" disabled={loading} loading={loading}>
          SEND
        </Button>
        <MailSuccessDialog
          isOpen={open}
          toggleModal={() => setOpen((prev) => !prev)}
          title={MailJson['buying-with-form'].mail.title}
          description={MailJson['buying-with-form'].mail['description']}
        />
      </div>
    </form>
  );
}
